export default {
    "feedback":{
        "text" : "",
        "title" : "Envoyer un feedback à l'admin Sinequa",
        "content" : {
            "text" : "Contenu",
            "title" : "Proposer d'ajouter du contenu ou d'améliorer le contenu actuel"
        },
        "ui" : {
            "text" : "Interface Utilisateur",
            "title" : "Proposer des améliorations d'interfaces utilisateur"
        },
        "lang" : {
            "text" : "Langage",
            "title" : "Proposer des améliorations linguistiques, comme des nouveaux mots et synonymes à ajouter aux dictionaires (cela affecte directement la pertinence du moteur de recherche)"
        },
        "other" : {
            "text" : "Autre",
            "title" : "Proposer des fonctionnalités supplémentaires et autres idées d'améliorations"
        },
        "thankyou": "Merci pour votre commentaire !",
        "quality" : {
            "label" : "Qualité du document:"
        },
        "relevance" : {
            "label" : "Pertinence du document:"
        },
        "labels" : {
            "public" : {
                "label" : "Tags:"
            },
            "private" : {
                "label" : "Tags privés:"
            }
        }
    },
};
